var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signup"},[_c('Sidebar'),_c('Form',{attrs:{"signup":true,"msg":"Sign Up"},on:{"formSubmitted":function($event){return _vm.signupUser($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }